import { render, staticRenderFns } from "./DocumentationListView.vue?vue&type=template&id=1dc7c3b9&scoped=true&"
import script from "./DocumentationListView.vue?vue&type=script&lang=js&"
export * from "./DocumentationListView.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationListView.vue?vue&type=style&index=0&id=1dc7c3b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc7c3b9",
  null
  
)

export default component.exports